<!-- Геозоны верх -->
<div class="tabpage geozones hidden" id="geozones_top">
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{ 'Find by name'| translate }}" />
  </div>
  <div class="choosegroup dropdown dropclick" id="zonegroups">
    <input type="text" readonly="readonly" />
    <div class="dropcontent dontclose">
      <div class="dropcontentinset">
        <!-- button class="btnaddgroup">{{ 'Add' | translate }}</button-->
        <input type="text" class="searchinput" placeholder="{{ 'Group search'| translate }}" />
        <ul class="group-filter-list"></ul>
      </div>
    </div>
    <div class="objdropdown dropdown dropclick dropclickjs">
      <ul>
        <li>{{ 'Select' | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="tableheader">
    <input onclick="selectAllLeft(this)" type="checkbox">
    <label class="check_img check_sortaz">
      <input type="checkbox">
      <span></span>
    </label>
    <ng-container *ngIf="canCreateGeozone">
      <button class="btn_img btn_graydark btn_addpoint" title="{{'Add geozone' | translate}}"></button>
      <button class="btn_img btn_graydark btn_createway" title="{{'Add geozone' | translate}}"></button>
      <button class="btn_img btn_graydark btn_createzone" title="{{'Add geozone' | translate}}"></button>
    </ng-container>

  </div>
  <div class="tablewrap">
    <div class="table">
      <table id="zonelist"></table>
      <div class="objdropdown dropdown dropclick dropclickjs">
        <ul>
          <li>{{ 'Show on the map' | translate }}</li>

          <!--
            <li class="separator"></li>
            <li>{{ 'Edit' | translate }}</li>
            <li>{{ 'Delete' | translate }}</li>
            -->
        </ul>
      </div>
    </div>
  </div>
  <app-pagination [viewmode]="'pages hideitemscount'" class="geozonespager"></app-pagination>
</div>
<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
